/**
 * TabNav Component
 * Reusable horizontal tab navigation component.
 */

import type { ReactNode } from 'react';
import styles from './TabNav.module.css';

interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
}

interface TabNavProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

/**
 * Horizontal tab navigation component.
 */
export const TabNav = ({ tabs, activeTab, onTabChange, className = '' }: TabNavProps) => {
  return (
    <div className={`${styles.tabNav} ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.icon && <span className={styles.tabIcon}>{tab.icon}</span>}
          <span className={styles.tabLabel}>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};
